
import { useOptimizedStats } from './useOptimizedStats';
import { useMemo } from 'react';

export const useIndexStats = () => {
  const { data: optimizedData, isLoading, error } = useOptimizedStats();

  const processedData = useMemo(() => {
    if (!optimizedData) {
      return {
        stats: {
          totalEmployees: 0,
          attendanceRate: 0,
          totalClients: 0,
          totalCompanies: 0
        },
        employees: [],
        loading: isLoading,
        error
      };
    }

    // التحقق من نوع البيانات وتحويلها
    const statsData = (typeof optimizedData === 'object' && optimizedData !== null && !Array.isArray(optimizedData)) 
      ? optimizedData as any : {
      employees: { total: 0, present: 0, absent: 0, late: 0, departments: 0 },
      clients: { total: 0, by_status: {} },
      bookings: { total: 0, this_month: 0, total_revenue: 0 },
      tasks: { total: 0, pending: 0, in_progress: 0, overdue: 0 },
      hotels: { total: 0, countries: 0, cities: 0, average_stars: 0 }
    };

    // حساب معدل الحضور
    const attendanceRate = statsData.employees && typeof statsData.employees === 'object' && statsData.employees.total > 0 
      ? Math.round((statsData.employees.present / statsData.employees.total) * 100)
      : 0;

    return {
      stats: {
        totalEmployees: (statsData.employees && typeof statsData.employees === 'object') ? statsData.employees.total || 0 : 0,
        attendanceRate,
        totalClients: (statsData.clients && typeof statsData.clients === 'object') ? statsData.clients.total || 0 : 0,
        totalCompanies: 0 // سنحتاج لإضافة هذا للدالة لاحقاً
      },
      employees: [], // البيانات التفصيلية ستأتي من hook منفصل
      loading: isLoading,
      error
    };
  }, [optimizedData, isLoading, error]);

  return processedData;
};
